// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"feef9545","455":"c4e81f6b","977":"d7d4102c"}[chunkId] + ".chunk.js";
};